import { Paper, Typography } from "@mui/material";
import { formatSeconds } from "../../store/formatUtil";
import { useGlimpsedFiles } from "../../store/filteredFiles/hooks";

export default function GlimpsedFileAudioTime() {
  const { clipTime, originalTime } = useGlimpsedFiles();

  return (
    <Paper
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 3,
        justifyContent: "center",
        height: 40,
        zIndex: 2,
      }}
    >
      <Typography flex={1} lineHeight={1} textAlign="right" variant="overline">
        <span style={{ fontWeight: 500, marginRight: 4 }}>Clip Time:</span>
        {formatSeconds(clipTime.toFixed(3))}
      </Typography>
      <Typography flex={1} lineHeight={1} textAlign="left" variant="overline">
        <span style={{ fontWeight: 500, marginRight: 4 }}>Original Time:</span>
        {formatSeconds(originalTime.toFixed(3))}
      </Typography>
    </Paper>
  );
}
